export const fetchAddressesMock = {
  addresses: [
    {
      uuid: "668447884976f0115b18eb6d07a34cec",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-284",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "10",
      location: { latitude: 52.164_055, longitude: 20.933_588, xyClass: 240 },
    },
    {
      uuid: "9f64907fc34cd80fd6878ebf37582430",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-183",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "11",
      location: { latitude: 52.164_808, longitude: 20.930_918, xyClass: 240 },
    },
    {
      uuid: "1c403383149cc1c0e63807cb51659e41",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "111A",
      location: { latitude: 52.177_346, longitude: 20.944_365, xyClass: 240 },
    },
    {
      uuid: "386793ba0edea3d554feed8f19bc82ec",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "121",
      location: { latitude: 52.178_026, longitude: 20.945_082, xyClass: 240 },
    },
    {
      uuid: "b4b1c61b901668745a1cfdc9c9c8e05d",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "131A",
      location: { latitude: 52.179_218, longitude: 20.945_944, xyClass: 240 },
    },
    {
      uuid: "93809273dc5962a838c80f3106337b97",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-284",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "16B",
      location: { latitude: 52.164_702, longitude: 20.933_486, xyClass: 240 },
    },
    {
      uuid: "48c2c0353fbfb8ed0e99b2252f337be6",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "173",
      location: { latitude: 52.1838, longitude: 20.951_408, xyClass: 240 },
    },
    {
      uuid: "c09d3f709daaea23dcddbaf931d6ffa5",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "177",
      location: { latitude: 52.184_022, longitude: 20.951_677, xyClass: 240 },
    },
    {
      uuid: "9294211036466c33fd8f723a0a909ec7",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-284",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "18B",
      location: { latitude: 52.165_002, longitude: 20.933_968, xyClass: 240 },
    },
    {
      uuid: "4262a1229a961b1405478b5cea90893c",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-284",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "20",
      location: { latitude: 52.165_431, longitude: 20.932_978, xyClass: 240 },
    },
    {
      uuid: "e2a00f6acc1eaf0aa7cd15ba65c7665a",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-219",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "220",
      location: { latitude: 52.187_029, longitude: 20.955_85, xyClass: 240 },
    },
    {
      uuid: "102f9cd532e07476970ac5fb241da32f",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-219",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "224",
      location: { latitude: 52.187_127, longitude: 20.9565, xyClass: 240 },
    },
    {
      uuid: "66982ffd0b54f5c28a7cd3802bc27f6c",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-219",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "226",
      location: { latitude: 52.187_484, longitude: 20.956_187, xyClass: 240 },
    },
    {
      uuid: "e222e25e9bfcd166a448b0801e97e3df",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-183",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "23",
      location: { latitude: 52.166_016, longitude: 20.932_482, xyClass: 240 },
    },
    {
      uuid: "42e9b3a89b2407405bda38364aebe384",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "231",
      location: { latitude: 52.188_978, longitude: 20.956_453, xyClass: 240 },
    },
    {
      uuid: "2759b82fcc13d55b89448d264328244f",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-180",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "239/241",
      location: { latitude: 52.190_033, longitude: 20.957_488, xyClass: 240 },
    },
    {
      uuid: "503e8aa0faa5e6d9bfb0d8e941102e6f",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-183",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "23A",
      location: { latitude: 52.166_158, longitude: 20.931_946, xyClass: 240 },
    },
    {
      uuid: "a66eca91a760586eaf1514a6c7752fa5",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-133",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "255",
      location: { latitude: 52.191_735, longitude: 20.958_913, xyClass: 240 },
    },
    {
      uuid: "2598d19e4ffc37e379a774ed1ca8b752",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-210",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "268",
      location: { latitude: 52.193_267, longitude: 20.961_653, xyClass: 240 },
    },
    {
      uuid: "51d5be625c9dcf4d109d43651731562a",
      state: "mazowieckie",
      county: "Warszawa",
      municipality: "Włochy",
      city: "Warszawa",
      cityDistricted: "Warszawa",
      zip: "02-210",
      street: "Krakowska",
      street1: "Krakowska",
      streetPrefix: "al.",
      streetTeryt: "Aleja Krakowska",
      houseNumber: "270",
      location: { latitude: 52.193_805, longitude: 20.962_13, xyClass: 240 },
    },
  ],
};
